import React, { useState, useRef, useEffect } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import "./TestimonialSlider.css";

const categories = ['Transformations', 'Testimonials'];

const testimonials = [
  {
    title: "ON POINT DIET",
    description:
      "I have been taking my diet from Paushtikk Switch from last 2 years. Satisfied with the service, food quality & nutrition detailing. Happy that young entrepreneurs are coming up with such businesses",
    name: "Bala Dabbedi",
    role: "Co-Founder FITTR & INFS",
    image: "/img/te1.png",
  },
  {
    title: "ON POINT DIET",
    description:
      "Following a diet is very difficult without proper guidance and service provider. Paushtikk helped me with proper diet plan and tasty diet meals at my convenience",
    name: "Dr. Rajesh Deshmukh",
    role: "District Collector – Pune",
    image: "/img/te3.png",
  },
  {
    title: "ON POINT DIET",
    description:
      "I have been taking meals from Paushtikk for my competitions and I just cannot believe that I'm dieting. Trust me, with Paushtikk dieting just got easier",
    name: "Siddharth Pattan",
  role: "Fitness & Nutrition Coach",
    image: "/img/te2.png",
  },
];
const transformationPairs = [
  {
    before: "img/trns1.webp",
    after: "img/trns11.webp",
    name: "Subash Yadav"
  },
  {
    before: "img/trns2.webp",
    after: "img/trns22.webp",
    name: "Deepak Paushkar"
  },
  {
    before: "img/trns3.webp",
    after: "img/trns33.webp",
    name: "Irshad Shaikh"
  },
  {
    before: "img/trns4.webp",
    after: "img/trns44.webp",
    name: "Vrushikesh Admane"
  },
  {
    before: "img/trns5.webp",
    after: "img/trns55.webp",
    name: "Prajyot Kamble"
  },
    {
    before: "img/trns6.webp",
    after: "img/trns66.webp",
    name: "Sapna Thorat"
  }
];

const NextArrow = ({ onClick }) => (
  <div className="custom-arrow next" onClick={onClick}>
    &#8250;
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="custom-arrow prev" onClick={onClick}>
    &#8249;
  </div>
);

const Testimonial = () => {
  const [selectedCategory, setSelectedCategory] = useState('Transformations');
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const transformationSliderRef = useRef();
  const testimonialSliderRef = useRef();

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    adaptiveHeight: true,
    swipeToSlide: true,
    touchMove: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: !isMobile,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    
    <div>
      <section className="heronew">
  
  <div className="hero-content">
  <h1 className="headline">
  <span style={{ color: '#2F2F2F' }}>Client Testimonials</span>
</h1>

<p className='subehad'>  Customers who chose to change their life and we helped them do so.</p>
  </div>

</section>
     <div className='testimonial-wrapper'>
      <div className="category-tabs">
        {categories.map((cat) => (
          <button
            key={cat}
            className={`tab-button ${selectedCategory === cat ? 'active' : ''}`}
            onClick={() => setSelectedCategory(cat)}
          >
            {cat}
          </button>
        ))}
      </div>

      <div className="slider-container">
      {selectedCategory === 'Transformations' && (
  <div className="transformation-slider">
    <Slider ref={transformationSliderRef} {...settings}>
      {transformationPairs.map((item, index) => (
        <div key={index} className="slider-item">
          <div className="transformation-card">
            <div className="image-pair">
              <div className="image before">
                <img src={item.before} alt="Before" loading="lazy" style={{ width: '100%' }} />
              </div>
              <div className="image after">
                <img src={item.after} alt="After" loading="lazy" style={{ width: '100%' }} />
              </div>
            </div>
            <div className="label-row">
              <span className="before-label">Before</span>
              <span className="after-label">After</span>
            </div>
          </div>
          <div className="name">{item.name}</div>
        </div>
      ))}
    </Slider>

    {isMobile && (
      <div className="mobile-arrows">
        <button onClick={() => transformationSliderRef.current?.slickPrev()}>&lt;</button>
        <button onClick={() => transformationSliderRef.current?.slickNext()}>&gt;</button>
      </div>
    )}
  </div>
)}


        {selectedCategory === 'Testimonials' && (
          <div className="testimonial-slider">
            <Slider ref={testimonialSliderRef} {...settings}>
              {testimonials.map((t, index) => (
                <div key={index} className="slider-item">
                  <div className="testimonial-card testheight" style={{ padding: '25px' }}>
                    <h4>{t.title}</h4>
                    <p  style={{ height: '130px'}}>{t.description}</p>
                    <div className="client-info">
                      <img src={t.image} alt={t.name} loading="lazy"/>
                     <div>
                        <div className='classusername'>{t.name}</div>
                        <div className='classrol'>{t.role}</div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
            {isMobile && (
              <div className="mobile-arrows arrowfortopzero">
                <button onClick={() => testimonialSliderRef.current?.slickPrev()}>&lt;</button>
                <button onClick={() => testimonialSliderRef.current?.slickNext()}>&gt;</button>
              </div>
            )}
          </div>
        )}
      </div>
      <br/>  <br/>
    </div>
    </div>
  );
};

export default Testimonial;
